import { toApiError } from '../../lib/api-error';

export async function throwReleaseApiError(response: Response, fallback: string): Promise<never> {
  throw await toApiError(response, fallback);
}
